import type { ComponentProps } from "react";
import { tv } from "tailwind-variants";

import { ProgressBackToCareplanButton } from "@/domains/progress/components/progress-back-to-careplan-button";
import {
  PROGRESS_ERROR_BODY,
  PROGRESS_ERROR_TITLE,
  PROGRESS_RETRY_LABEL,
} from "@/domains/progress/utils/progress-page-copy";
import { Button, Heading } from "@/ui";

const errorLayout = tv({
  base: "flex w-full max-w-4xl grow flex-col items-start gap-4 self-center px-4 pt-8 pb-16 sm:px-6 sm:pt-16",
});

export type ProgressPageErrorProps = ComponentProps<"div"> & {
  onRetry?: () => void;
};

export const ProgressPageError = ({ className, onRetry, ...props }: ProgressPageErrorProps) => {
  return (
    <div className={errorLayout({ className })} {...props}>
      <Heading level={1}>{PROGRESS_ERROR_TITLE}</Heading>

      <p className="text-content-secondary" role="alert">
        {PROGRESS_ERROR_BODY}
      </p>

      <div className="mt-2 flex flex-wrap gap-3">
        {onRetry === undefined ? null : (
          <Button onClick={onRetry} size="lg">
            {PROGRESS_RETRY_LABEL}
          </Button>
        )}

        <ProgressBackToCareplanButton />
      </div>
    </div>
  );
};
